const NEAProject = () => {
  const imgStyle = {
    margin: "10px 0",
    boxShadow: "0 0 7px 5px rgba(0, 0, 0, 0.05)",
  }
  return (
    <div>
      <h3>Network Performace Tracker</h3>

      <p style={{ maxWidth: "800px" }}>
        This was a data science project I made as part of my A level in Computer
        Science. It was a tool that could be used by network operators such as
        Vodafone and EE to detect faults and areas of low performance in their
        network by utilising social media. I still consider this to be the most
        difficult project I have ever made, but I gained so many new skills such
        as using Pandas, databases, displaying data, and working with APIs, and
        it sparked my interest in data science which I will look to do more of
        in the future.{" "}
        <a href="https://drive.google.com/file/d/1mqW2cKh5e_F-qH7vfOX80aQrg5VPecfG/view?usp=sharing">
          View the full project report
        </a>
        <br />
        <br /> The application listened for tweets across the uk about the
        network, got the location information of these, and used Natural
        Language Processing to find out whether they were positive or negative.
        It would then average these across each region and display a map of the
        uk, showing which regions were people tweeting most negatively about the
        network. It also displayed a graph of these tweets against their
        sentiment value (how positive/negative they were) across the last week.
        And it displayed a graph of the overall tweet sentiment for each of the
        big 4 network operators in the uk, to compare their performance. The
        project was written in Python and used Dash and Plotly for the UI. For
        data storage and manipulation it used sqlite3 and Pandas - in particular
        using advanced Pandas aggregation functions, grouping tweets by network,
        region and week simultaneously, then using average, max, sum, and count.
        And, of course, used the Twitter API for the tweets.{" "}
      </p>
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2021-04-04 at 15.11.14.png"
        alt="screenshot"
        width="100%"
        display="inline-block"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2021-04-10 at 15.01.36.png"
        alt="screenshot"
        width="100%"
        display="inline-block"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2021-04-16 at 19.04.59.png"
        alt="screenshot"
        width="100%"
        display="inline-block"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2021-04-05 at 11.27.26.png"
        alt="screenshot"
        width="100%"
        display="inline-block"
      />
      <img
        style={imgStyle}
        src="screenshots/Screenshot 2021-04-16 at 19.05.14 copy.png"
        alt="screenshot"
        width="100%"
        display="inline-block"
      />
    </div>
  )
}

export default NEAProject
